<template>
  <div class="contauner-fliud">
    <header >
      <div class="logo">
        <img class="img1" src="../assets/img/logo  basie.png" alt="">
        <img class="img2 hide" src="../assets/img/LOGO.png" alt="">
      </div>
      <ul>
        <router-link :to="{ path:'home'}" tag="li" >首页</router-link>
        <router-link :to="{ path:'news',query:{id:8,page:1,queryTime:4}}" tag ="li" class="bannerOne" >新闻动态</router-link>
        <router-link :to="{ path:'product'}" tag ="li" >产品服务</router-link>
        <router-link :to="{ path:'recruit'}" tag ="li">联系我们 </router-link>
      </ul>
    </header>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios'
  export default {
    data() {
      return {
      };
    },
    methods: {
    },
    mounted() { 
    },
  }
</script>
<style scoped lang="scss">
  @import '@/lib/reset.scss';
  *{margin: 0;padding: 0;}
  .hide{display: none}
  header{
    width:100%;
    height: 65px;
    position: fixed;
    z-index:1;
    padding:5px 0;
    font-size: 17px;
    color:#fff;
  }
  // 鼠标滑动时加背景
  .headerbg{
    width:100%;
    position: fixed;
    z-index:1;
    color:#666 !important;
    animation:animatedBackground 0.3s ease-in-out 0s 1 alternate forwards;
  }
  // 背景动画
  @keyframes animatedBackground {
    from{background: transparent;height: 110px;}
    to{background: #eeeded;height:75px;}
  } 
  // 新闻详情中新闻动态字体样式
  .bannerOne{
    font-size: 25px;
    color:#fff;
    border-bottom:2px solid #fff;
  }
  .bannerTwo{
    font-size: 25px;
    color:#004098;
    border-bottom:2px solid #004098;
  }
  //滑动加背景后，选中字体的样式
  .headerbg .router-link-active{
    color:#004098;
    border-bottom:2px solid #004098;
  }
  .headerbg  ul li:hover{
    color:#004098;
    border-bottom:2px solid #004098;
  } 
  // 图标
  header .logo{
    float: left;
    margin-left:3.5%;
    margin-top: 0.45%;
  }
  // 导航
  header ul{ 
    float:right; 
    width:33%;
    margin-top:3px;
  }
  header ul li{ 
    margin-left:2%;
    width:20%; 
    height:54px;
	  line-height:50px;
    font-size: 17px;
    display: inline-block;
	  text-align:center;
	  overflow: hidden;
  }
  header ul li:hover{
    cursor:pointer;
    font-family: "思源黑体";
    font-size: 25px;
    color:#fff;
    border-bottom:2px solid #fff;
    overflow: hidden;
  }
  .router-link-active{
    font-family: "思源黑体";
    font-size: 25px;
    color:#fff;
    border-bottom:2px solid #fff;
  }
  @media screen and (max-width:1680px) and (min-width:1440px){
    header .logo{
      float: left;
      margin-left:6%;
    }
    header .logo img{
      width:87%;
    }
    header ul{ 
      width:40%;
      text-align: right;
      margin-right:5%;
    }
    header ul li{ 
      width:20%; 
      height:60px;
	    line-height:60px;
    }
   
  }
  @media screen and (max-width:1440px) and (min-width:1366px){
    header .logo{
      float: left;
      margin-left:6%;
    }
    header .logo img{
      width: 80%;
    }
    header ul{ 
      width:40%;
      text-align: right;
      margin-right:5%;
    }
    header ul li{ 
      width:19%; 
      height:55px;
	    line-height:55px;
    }
    header ul li:hover{
      font-size: 20px;
    }
    .bannerOne{
      font-size: 20px;
    }
    .bannerTwo{
      font-size: 20px;
    }
    .router-link-active{
      font-size: 20px;
    }
    // header ul :nth-child(2){
    //   font-size: 23px;
    // }
    @keyframes animatedBackground {
      from{background: transparent;height: 100px;}
      to{background: #eeeded;height:68px;}
    }
  }
  @media screen and (max-width:1366px) and (min-width:1280px){
    header .logo{
      float: left;
      margin-left:6%;
    }
    header .logo img{
      width:70%;
    }
    header ul{
      width:40%;
      text-align: right;
      margin-right:5%;
    }
    header ul li{ 
      width:18%; 
      height:50px;
	    line-height:50px;
       font-size: 16px;
    }
    header ul li:hover{
      font-size: 20px;
    }
    .bannerOne{
      font-size: 20px;
    }
    .bannerTwo{
      font-size: 20px;
    }
    .router-link-active{
      font-size: 20px;
    }
    // header ul :nth-child(2){
    //   font-size: 21px;
    // }
    @keyframes animatedBackground {
      from{background: transparent;height: 100px;}
      to{background: #eeeded;height:65px;}
    }
  }
  @media screen and (max-width:1280px) and (min-width:1024px){
     header .logo{
      float: left;
      margin-left:6%;
    }
    header .logo img{
      width:63%;
    }
    header ul{ 
      width:40%;
      text-align: right;
      margin-right:6%;
    }
    header ul li{ 
      width:19%; 
      height:45px;
	    line-height:46px;
      font-size: 16px;
    }
    header ul li:hover{
      font-size: 20px;
    }
    .bannerOne{
      font-size: 20px;
    }
    .bannerTwo{
      font-size: 20px;
    }
    .router-link-active{
      font-size: 20px;
    }
    // header ul :nth-child(2){
    //   font-size: 20px;
    // }
     @keyframes animatedBackground {
      from{background: transparent;height:90px;}
      to{background: #eeeded;height:60px;}
    }
  }
  @media screen and (max-width:1024px)and (min-width:650px){
    header .logo{
      float: left;
      margin-left:6%;
    }
    header .logo img{
      width:65%;
    }
    header ul{ 
      width:40%;
      text-align: right;
      margin-right:6%;
    }
    header ul li{ 
      width:20%; 
      height:45px;
	    line-height:50px;
       font-size: 16px;
    }
    header ul li:hover{
      font-size:18px;
    }
    .bannerOne{
      font-size: 18px;
    }
    .bannerTwo{
      font-size: 18px;
    }
    .router-link-active{
      font-size:18px;
    }
    @keyframes animatedBackground {
      from{background: transparent;height:90px;}
      to{background:#eeeded;height:60px;}
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Headers.vue